/**
 * Les « fichiers » de Scanyt (accounts.json, ignored.json…), rangés dans
 * IndexedDB, c'est-à-dire dans ce navigateur et nulle part ailleurs.
 *
 * server.js lit et écrit ses fichiers de façon synchrone : tout est donc
 * chargé en mémoire au démarrage (charger()), puis chaque écriture est
 * recopiée dans IndexedDB en arrière-plan, dans l'ordre.
 */
const BASE = 'scanyt';
const MAGASIN = 'fichiers';

export const fichiers = new Map();
let base = null;
let file = Promise.resolve();
export let persistant = true;

function ouvrir() {
  return new Promise((ok, ko) => {
    const requete = indexedDB.open(BASE, 1);
    requete.onupgradeneeded = () => requete.result.createObjectStore(MAGASIN);
    requete.onsuccess = () => ok(requete.result);
    requete.onerror = () => ko(requete.error);
  });
}

function attendre(requete) {
  return new Promise((ok, ko) => {
    requete.onsuccess = () => ok(requete.result);
    requete.onerror = () => ko(requete.error);
  });
}

export async function charger() {
  try {
    base = await ouvrir();
    const magasin = base.transaction(MAGASIN).objectStore(MAGASIN);
    const [cles, valeurs] = await Promise.all([
      attendre(magasin.getAllKeys()),
      attendre(magasin.getAll())
    ]);
    cles.forEach((cle, i) => fichiers.set(cle, valeurs[i]));
  } catch {
    // Navigation privée stricte, stockage bloqué : Scanyt marche quand même,
    // mais les résultats disparaîtront à la fermeture de l'onglet.
    persistant = false;
    base = null;
  }
}

function enregistrer(action) {
  if (!base) return;
  file = file
    .then(() => new Promise((ok) => {
      const transaction = base.transaction(MAGASIN, 'readwrite');
      action(transaction.objectStore(MAGASIN));
      transaction.oncomplete = ok;
      transaction.onerror = ok;
      transaction.onabort = ok;
    }));
}

export function ecrire(chemin, contenu) {
  fichiers.set(chemin, contenu);
  enregistrer((m) => m.put(contenu, chemin));
}

export function effacer(chemin) {
  fichiers.delete(chemin);
  enregistrer((m) => m.delete(chemin));
}

/** Attend que toutes les écritures soient parvenues dans IndexedDB. */
export function synchronise() {
  return file;
}
